export default {"src":"/_next/static/media/aave.1262788a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};